<div
  data-move-list-el='timestamp'
  data-ply={ply}
  data-time={timestampData.timestamp}
  class={`time-${color}`}
  style={`
    ${MoveListComponent.CSSVariables.TimeValue}: ${timestampData.timestamp}; 
    ${$baseTime
    ? `${MoveListComponent.CSSVariables.TimeBarWidth}: ${getBarWidth(Number(timestamp), $baseTime)}px;`
    : `${MoveListComponent.CSSVariables.TimeBarWidth}: ${timestampData.width}px;`
    }
  `}>
  {timestampData.value}
</div>

<script lang="ts">
import { MoveListComponent } from 'components/move-list/config/types';
import { getTimestampData } from 'components/move-list/helpers/format-time';
import { getBarWidth } from 'components/move-list/helpers/get-bar-width';
import { getContext } from 'svelte';
import { MoveListPlugin } from 'chessboard/plugins/move-list/config/types';
import type { ContextShape } from '../store/types';

export let timestamp: number | null;
export let color: string;
export let ply: number | undefined;

const { store } = getContext<ContextShape>(MoveListPlugin.Name);
const { baseTime, translations, displayTimeInClockFormat } = store;

$: timestampData = getTimestampData({
  displayTimeInClockFormat: $displayTimeInClockFormat,
  timestamp: Number(timestamp),
  translations: $translations,
});
</script>
